import React, { useEffect } from "react";
import { Form, Input, Row, Select, Button, Col, Modal, message } from "antd";
import { CharacterVerify } from "../../../Utility/RegExp";
import { useTranslation } from "react-i18next";
import { setEditCityVisible } from "../store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useUpdateLocations } from "../queries";

const { Option } = Select;

interface Irestore {
  name?: string;
  id: string;
}

interface Iprop {
  selectedRowKeys: string[];
  setSelectedRowKeys(d: string[]): void;
}

const EditCityModal: React.FC<Iprop> = React.memo(({ selectedRowKeys, setSelectedRowKeys }) => {
  const { t } = useTranslation();
  const disp = useAppDispatch();
  const { restore, editCityVisible } = useAppSelector((state) => state.topology);
  const { stateCid } = useAppSelector((state) => state.global);
  const [form] = Form.useForm();
  const { mutateAsync: updateLocationMutation, isLoading: updateLocationLoading } = useUpdateLocations(stateCid);

  useEffect(() => {
    form.setFieldsValue({
      devices: selectedRowKeys,
    });
    setSelectedRowKeys([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editCityVisible === true]);

  const updateLocationOnFinish = (value: any) => {
    updateLocationMutation({ value })
      .then(() => {
        disp(setEditCityVisible(false));
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });

    form.resetFields();
    setSelectedRowKeys([]);
  };

  return (
    <Modal
      visible={editCityVisible}
      onCancel={() => {
        disp(setEditCityVisible(false));
        form.resetFields();
      }}
      destroyOnClose={true}
      centered={true}
      title={t("ISMS.Edit Location")}
      footer={[
        <Button loading={updateLocationLoading} key="Cancel" onClick={() => disp(setEditCityVisible(false))}>
          {t("ISMS.Cancel")}
        </Button>,
        <Button key="Save" type="primary" loading={updateLocationLoading} onClick={() => form.submit()}>
          {t("ISMS.Submit")}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={(value) => updateLocationOnFinish(value)}>
        <div className="formwrap">
          <Row gutter={24} justify="center">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                name={"devices"}
                label={t("ISMS.SelectDevice")}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder={t("ISMS.Device")} maxTagCount={1} mode={"multiple"}>
                  {restore?.map((item: Irestore, index: number) => (
                    <Option key={index} value={item.id}>
                      {item.name !== "" ? item.name : item.id}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mt-3">
              <Form.Item name={"city_name"} label={t("ISMS.Location")} rules={[CharacterVerify]}>
                <Input placeholder={t("ISMS.InputaLocation")} maxLength={30} />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Modal>
  );
});

export default EditCityModal;
